import TCBookedLegsCollectionUIModel from './tc-booked-legs-collection';
import TCPassengersCollectionUIModel from './tc-passengers-collection';
import { get } from 'lodash';

class PNRTCReservationUIModel {
  constructor({
    bookedLegCollection = [],
    clid = '',
    creationDate = null,
    currency = {},
    divideSplitDetails = {},
    genericSpecialRequests = [],
    isAgencyReservation = null,
    isDirectSale = null,
    isEmployee = null,
    isStandBy = null,
    lastName = '',
    mcStayType = null,
    oldBookedLegCollection = [],
    otherAirlineReservationCode = '',
    passengerNumbers = '',
    passengers = [],
    paymentsMethods = [],
    remarks = [],
    reservationCode = '',
    salesChannel = '',
    ticketDateTimeLimit = '',
    ticketTimeLimit = null,
    transactionId = null,
    tripType = '',
    typeReservation = '',
  } = {}) {
    this.bookedLegsCollection = new TCBookedLegsCollectionUIModel(bookedLegCollection);
    this.clid = clid;
    this.creationDate = creationDate;
    this.currency = currency;
    this.divideSplitDetails = divideSplitDetails;
    this.genericSpecialRequests = genericSpecialRequests;
    this.isAgencyReservation = isAgencyReservation;
    this.isDirectSale = isDirectSale;
    this.isEmployee = isEmployee;
    this.isStandBy = isStandBy;
    this.lastName = lastName;
    this.mcStayType = mcStayType;
    this.oldBookedLegCollection = new TCBookedLegsCollectionUIModel(oldBookedLegCollection);
    this.otherAirlineReservationCode = otherAirlineReservationCode;
    this.passengerNumbers = passengerNumbers;
    this.passengersCollection = new TCPassengersCollectionUIModel(passengers);
    this.paymentsMethods = paymentsMethods;
    this.remarks = remarks;
    this.reservationCode = reservationCode;
    this.salesChannel = salesChannel;
    this.ticketDateTimeLimit = ticketDateTimeLimit;
    this.ticketTimeLimit = ticketTimeLimit;
    this.transactionId = transactionId;
    this.tripType = tripType;
    this.typeReservation = typeReservation;
  }

  getInitialPreviosflights(legNum) {
    const initialFlights = {};
    const legs = this.bookedLegsCollection.legs;

    legs.map( (leg, index) => {
      if (legNum === index) {
        if (leg.segmentsCollection.segments[leg.segmentsCollection.segments.length - 1]) { // Cuando es el ultimo segmento
          initialFlights.arrivalAirport = leg.segmentsCollection.segments[leg.segmentsCollection.segments.length - 1].arrivalAirport;
        }
        initialFlights.departureAirport = leg.segmentsCollection.segments[0].departureAirport;
      }
    });
    return initialFlights;
  }

  getInitialFlightsList() {
    const legs = this.bookedLegsCollection;
    return legs.map( (leg) => {
      const firstSegment = leg.segmentsCollection.segments[0];
      const lastSegment = leg.segmentsCollection.segments[leg.segmentsCollection.segments.length - 1];

      const departureAirport = get(firstSegment, 'departureAirport', null);
      const arrivalAirport = get(lastSegment, 'arrivalAirport', null);

      return {
        departureAirport,
        arrivalAirport,
      };
    });
  }

  getInitialFlightByLegIndex(legIndex) {
    const initialFlightsList = this.getInitialFlightsList();
    return initialFlightsList[legIndex];
  }
}

export default PNRTCReservationUIModel;